export const certifications = [
    {
        "courseParentTagId": [61, 62, 43, 47], // Westren, Piano, Guitar
        "courses": [501, 509, 505, 517], // Westren, Piano, Guitar]
        "certification": ["No Certificate", "Trinity", "RSL", "ABRSM", "Artium Certification","Not Sure!"],
        "gradeLevel": ["Initial/Debut", "1", "2", "3", "4", "5", "6", "7", "8"]
    },
    {
        "courseParentTagId": [1], //HC
        "courseId":[503],
        "certification": ["No Certificate", "Gandharv", "Artium Certification","Not Sure!"],
        "gradeLevel": ["Prarambhik", "Praveshika 1", "Praveshika 2", "Madhyama 1", "Madhayam 2", "Visharad 1", "Visharad 2", "Alankar", "Snatak"]
    },
    {
        "courseParentTagId": [2, 3, 4, 51, 55], // PFM
        "courseId":[511, 507,516, 519, 518, 521 ],
        "certification": ["No Certificate", "Gandharv", "Artium Certification","Not Sure!"],
        "gradeLevel": ["Prarambhik", "Praveshika 1", "Praveshika 2"]
    },
    {
        "courseParentTagId": [26, 34, 30, 38],
        "courseId":[512,513,514,515],
        "certification": ["No Certificate", "Carnatic (Any Recognised Board / University)", "Artium Certification","Not Sure!"],
        "gradeLevel": ["Elementary", "Intermediary 1", "Intermdeiary 2"]
    },
    {
        "courseParentTagId": [22], //Carnatic
        "courseId":[510],
        "certification": ["No Certificate", "Carnatic (Any Board/University)", "Artium Certification","Not Sure!"],
        "gradeLevel": ["BA", "Diploma ", "Certificate", "Senior", "Junior"]
    }
    // Others there is no certification process for now either from Artium or there are no certifications available outside. as recommended by Academics Team and
]